const list = {
    path: 'list',
    component: resolve => require(['@/pages/admin/messageCenter/list'], resolve),
}

export default list